// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__fTl3J","tab":"Tabs_tab__f-Yhf","active":"Tabs_active__+rAyk"};